/* ═══════════════════════════════════════════════════════════════
   Timesheets rebuild — week summary cards (week total, project,
   overhead, avg/day). 40h caution is a token-level visual only —
   var(--color-warning), same 40h threshold as before, no behavior
   gate (Tranche 2 sanctioned replacement for the hardcoded red).
   ═══════════════════════════════════════════════════════════════ */

import React from 'react';

export interface SummaryCardsProps {
  weekTotal: number;
  projectWeekTotal: number;
  overheadWeekTotal: number;
}

export function SummaryCards({
  weekTotal,
  projectWeekTotal,
  overheadWeekTotal,
}: SummaryCardsProps) {
  const cards = [
    {
      label: 'WEEK TOTAL',
      value: `${weekTotal}h`,
      color: weekTotal > 40 ? 'var(--color-warning)' : 'var(--ac)',
    },
    { label: 'PROJECT HOURS', value: `${projectWeekTotal}h`, color: undefined },
    { label: 'OVERHEAD HOURS', value: `${overheadWeekTotal}h`, color: undefined },
    {
      label: 'AVG / DAY (5d)',
      value: `${weekTotal > 0 ? (weekTotal / 5).toFixed(1) : '0.0'}h`,
      color: undefined,
    },
  ];

  return (
    <div style={{ display: 'flex', gap: 'var(--space-4)' }}>
      {cards.map((c) => (
        <div
          key={c.label}
          style={{
            background: 'var(--sf)',
            borderRadius: 'var(--radius-md)',
            border: '1px solid var(--bd)',
            padding: 'var(--space-3) var(--space-4)',
            flex: 1,
          }}
        >
          <div
            style={{
              fontSize: 'var(--font-size-sm)',
              color: 'var(--tm)',
              fontWeight: 600,
              marginBottom: 'var(--space-1)',
            }}
          >
            {c.label}
          </div>
          <div
            style={{
              fontSize: 'var(--font-size-2xl)',
              fontWeight: 700,
              fontFamily: "'JetBrains Mono', monospace",
              color: c.color || 'var(--tx)',
            }}
          >
            {c.value}
          </div>
        </div>
      ))}
    </div>
  );
}
